import { Store } from '@ngrx/store';
import { inject } from '@angular/core';
import { map, take } from 'rxjs';
import { selectUser } from '@shared/store/selectors/user.selectors';
import { profilePageTokenizer } from "@data-access/profiles";

/** Returns the current user's id for child routes (sites, studies) that don't have :id in the URL. */
export const profileContactIdResolver = () => {
  const store = inject(Store);
  return store.select(selectUser).pipe(
    take(1),
    map((user) => user?.id ?? ''),
  );
};

export const profileResolver = () => {
  const _store = inject(Store);
  const _profileTokenizer = profilePageTokenizer();

  _store
    .select(selectUser)
    .subscribe((user) => {
      if (user?.id) {
        _profileTokenizer.loadProfile(user?.is_internal ?? false, user?.id);
        _profileTokenizer.loadCountries();
        _profileTokenizer.loadDegrees();
        _profileTokenizer.loadSpecialties();
        _profileTokenizer.setIsStaff(!!(user?.is_internal && user?.role?.name?.toLowerCase() === 'staff'));
        if (user?.is_internal ?? false) {
          _profileTokenizer.loadRolesAndAttributes();
        }
      }
    })
    .unsubscribe();

  return !!_profileTokenizer;
};
